import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyReviews = lazyWithRetry(() => import("./Reviews"));

const Reviews = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyReviews {...props} />;

export default Reviews;
